import { render, staticRenderFns } from "./UiCheckboxCard.vue?vue&type=template&id=3c7225b8&"
import script from "./UiCheckboxCard.vue?vue&type=script&lang=js&"
export * from "./UiCheckboxCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports